import { apiClient } from "../../../api/client";
import * as ActionType from "./faq.type";
import { setToast } from "../../../util/toast";

export const getFAQ = () => async (dispatch) => {
  const res = await apiClient.get("faq/getFAQ");
  if (res.ok) {
    dispatch({ type: ActionType.GET_FAQ, payload: res.data?.faqs });
  } else {
    console.log(res.message);
  }
};

export const createFAQ = (data) => async (dispatch) => {
  const res = await apiClient.post("faq/createFAQ", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_FAQ, payload: res.data?.faq });
    setToast("success", "FAQ created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updateFAQ = (data) => async (dispatch) => {
  const res = await apiClient.patch("faq/updateFAQ", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_FAQ, payload: res.data?.faq });
    setToast("success", "FAQ updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const deleteFAQ = (id) => async (dispatch) => {
  const res = await apiClient.delete(`faq/deleteFAQ?faqId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_FAQ, payload: id });
    setToast("success", "FAQ deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
